import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// this is to set the state when the user opens a link witih the Stellar SEP7 URI. 
// the link will open the ebioro wallet and the user is redirected to the send or amount page.

const initialState='';

const openedSep7Uri = createSlice({
  name: 'openedSep7Uri',
  initialState,
  reducers: {
    setOpenedSep7Uri(state,action:PayloadAction<string>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default openedSep7Uri.reducer;

// Actions
export const {setOpenedSep7Uri} = openedSep7Uri.actions;


